
function userGaveConsent() {
  if (window.Cookiebot?.consent?.statistics) {
    return Promise.resolve()
  }

  return new Promise(resolve => {
    window.addEventListener("CookiebotOnAccept", () => {
      if (window.Cookiebot.consent.statistics) {
        resolve()
      }
    })
  })
}

export default userGaveConsent()
